import type { RouteRecordRaw } from "vue-router"

export const flattenSidebarRoutes = (routes: RouteRecordRaw[]) =>
  routes.flatMap((route) => {
    if (route.meta?.flattenInSidebar && route.children?.length) {
      return route.children
    }

    return route
  })
